// @flow

import * as React from 'react';
import EscapedCSS from 'app/common/lib/css/EscapedCSS';
import invariant from 'invariant';
import PropTypes from 'prop-types';

type Props = {|
  'amp-boilerplate'?: string,
  'amp-custom'?: string,
  css?: EscapedCSS,
  unsafeCSS?: string,
|};

export default function InlineStyle(props: Props) {
  const { css, unsafeCSS, ...rest } = props;
  const content = String(css || '') || unsafeCSS || '';
  const hasContent = !!content;

  if (process.env.NODE_ENV !== 'production') {
    invariant(
      hasContent,
      'Got missing or empty values for `css` and `unsafeCSS` properties in <InlineStyle/>. ' +
        'Please specify one of those properties.',
    );
  }

  /* eslint-disable react/no-danger */
  return hasContent ? (
    <style {...rest} dangerouslySetInnerHTML={{ __html: String(EscapedCSS.factory(content)) }} />
  ) : null;
  /* eslint-enable react/no-danger */
}

InlineStyle.propTypes = {
  'amp-boilerplate': PropTypes.string,
  'amp-custom': PropTypes.string,
  css: PropTypes.instanceOf(EscapedCSS),
  unsafeCSS: PropTypes.string,
};
